export interface PurchasePriceFromPriceListRequest {
  purchaseOrderHeaderId: string;
  productId: string;
  quantity: number;
  cutPrice: boolean;
  rrp: boolean;
}
